<template>
  <div class="build">
    <div>建设中，敬请期待......</div>
  </div>
</template>
<script>
export default {
  name: 'build',
  components: {  },
  data() {
    return {
    }
  },
  props: {
    isPath: Boolean,
  },
  mounted() {},
  created() {
  },
  methods: {
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/build.vue